<template>
  <view-page
      :baseRoute='baseRoute'
      :entity='entity'
      :button-access="componentAccess"
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >

    <template v-slot="{ model }">
      <mapping-renewal-form
          v-if="model"
          readonly
          v-model="model"
          card-title="View Product"
      />
    </template>
  </view-page>
</template>

<script>

import MappingRenewalForm from "@/views/pages/mapping-renewals/MappingRenewalForm";
import ViewPage from "@/views/components/Views/ViewPage";
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';
import NotificationMixin from '../../../components/mixins/NotificationMixin';

export default {
  name: "mappingRenewalsDetails",
  components: {
    MappingRenewalForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute: 'mapping-renewals',
      entity: 'Mapping Renewals',
      modelEntity: this.$api.mappingRenewals,
      title: '',
      componentAccess: {
        canEdit: {
          route: 'mapping-renewals.edit',
          access: false,
        },
        canDelete: {
          route: 'mapping-renewals.delete',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.ProductCode) {
        return '';
      }

      return "Product: " + params.ProductCode;
    }
  }
};
</script>

<style scoped>

</style>
